var script_loaded = false;

function loadJSscripts() {
  setTimeout(function() {
    if (!script_loaded) { loadJSscriptsNow(); }
  }, 2000);
}

function loadJSscriptsNow() {
  if (script_loaded) return;
  script_loaded = true;

  var scripts = document.getElementsByTagName('script');
  for (var i = 0; i < scripts.length; i++) {
    var dataSrc = scripts[i].getAttribute('data-src');
    if (dataSrc !== null) {
      scripts[i].setAttribute('src', dataSrc);
      delete scripts[i].dataset.src;
    }
  }

  var links = document.getElementsByTagName('link');
  for (var i = 0; i < links.length; i++) {
    var dataHref = links[i].getAttribute('data-href');
    if (dataHref !== null) {
      links[i].setAttribute('href', dataHref);
      delete links[i].dataset.href;
    }
  }

  setTimeout(function() {
    document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
    document.dispatchEvent(new CustomEvent('StartKernelLoading'));
  }, 400);
}

var activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress', 'touchmove'];
activityEvents.forEach(function(e) {
  window.addEventListener(e, loadJSscriptsNow, false);
});

window.addEventListener('load', loadJSscripts, false);
